/* eslint-disable jsx-a11y/mouse-events-have-key-events */
import React from 'react';

import { EnhancedReward } from './types';

import './DecoratePanelReward.scss';

interface Props {
  enhancedReward: EnhancedReward;
  onSelected: () => void;
}

/**
 * Component that shows renders a reward and a counter for how many there are.
 */
const DecoratePanelReward = ({ enhancedReward, onSelected }: Props): React.ReactElement => {
  const { reward: { imageUrl }, count } = enhancedReward;

  const available = count > 0;

  return (
    <div
      role="presentation"
      onClick={available ? onSelected : undefined}
      className="decorate-panel-reward"
    >
      <img
        className={available ? '' : 'unavailable'}
        src={imageUrl}
        alt={`${available ? 'available' : 'unavailable'} reward`}
      />

      {count > 1 && (
        <div className="counter">
          {count}
        </div>
      )}
    </div>
  );
};

export default DecoratePanelReward;
